exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-to-cart-cta .quantity-select-slim {\n  max-width: 100%;\n}\n@media (min-width: 1124px) {\n.add-to-cart-cta .quantity-select-slim {\n    max-width: 120px;\n}\n}\n.add-to-cart-cta .quantity-select-slim .quantity-select-action {\n  height: 53px;\n}\n", ""]);

// exports
